import { render, staticRenderFns } from "./AddBankAcc.vue?vue&type=template&id=54201467&"
import script from "./AddBankAcc.vue?vue&type=script&lang=js&"
export * from "./AddBankAcc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports